import { Slices as SlicesParagraph } from "@/__generated__/graphql";
import { preprocessFeatureCardVariantData } from "@components/FeatureCardVariant";
import { GridContainer } from '@theme/lib';
import dynamic from "next/dynamic";
import { ReactElement } from "react";

const Audio = dynamic(() => import('@components/Audio'), {
  ssr: true,
});

const RichText = dynamic(() => import('@components/RichText'), {
  ssr: true,
});

const ImpactBlock = dynamic(() => import('@components/ImpactBlock'), {
  ssr: true,
});

const PromoBlock = dynamic(() => import('@components/PromoBlock'), {
  ssr: true,
});

const Infographic = dynamic(() => import('@components/Infographic'), {
  ssr: true,
});

const NewsletterSignUpBlock = dynamic(() => import('@components/NewsletterSignUpBlock'), {
  ssr: true,
});

const ProjectInDetailSlider = dynamic(() => import('@components/ProjectInDetailSlider'), {
  ssr: true,
});

const Accordion = dynamic(() => import('@components/Accordion'), {
  ssr: true,
});
const FeatureCard = dynamic(() => import('@components/FeatureCard'), {
  ssr: true,
});
const Carousel = dynamic(() => import('@components/Carousel'), {
  ssr: true,
});
const DownloadButtons = dynamic(() => import('@components/DownloadButtons'), {
  ssr: true,
});
const SpeciesBlock = dynamic(() => import('@components/SpeciesBlock'), {
  ssr: true,
});
const Images = dynamic(() => import('@components/Images'), {
  ssr: true,
});
const GeneralListing = dynamic(() => import('@components/GeneralListing'), {
  ssr: true,
});
const ImageGallery = dynamic(() => import('@components/ImageGallery'), {
  ssr: true,
});
const InPageTabs = dynamic(() => import('@components/InPageTabs'), {
  ssr: true,
});
const Webform = dynamic(() => import('@components/Webform'), {
  ssr: true,
});
const FourPillars = dynamic(() => import('@components/FourPillars'), {
  ssr: true,
});
const TodayAtZooListing = dynamic(() => import('@components/TodayAtZooListing'), {
  ssr: true,
});
const InfoBlock = dynamic(() => import('@components/InfoBlock'), {
  ssr: true,
});
const FeatureCardVariant = dynamic(() => import('@components/FeatureCardVariant'), {
  ssr: true,
});
const TestimonialBlockQuote = dynamic(() => import('@components/TestimonialBlockQuote'), {
  ssr: true,
});
const EventListing = dynamic(() => import('@components/EventListing'), {
  ssr: true,
});
const TextImage = dynamic(() => import('@components/TextImage'), {
  ssr: true,
});
const ImageComparison = dynamic(() => import('@components/ImageComparison'), {
  ssr: true,
});
const VideoComponent = dynamic(() => import('@components/VideoComponent'), {
  ssr: true,
});

const Map = dynamic(() => import('@components/Map'), {
  ssr: false,
});


const renderParagraph = (paragraph: SlicesParagraph, index: number): ReactElement<any> => {
  switch (paragraph.__typename) {
    case "AudioParagraph":
      return (<Audio {...paragraph} key={paragraph.id} />);
    case "RichTextParagraph":
      return (
        <RichText {...paragraph} key={paragraph.id} />
      );
    case "ImpactBlockParagraph":
      return (
        <GridContainer className={paragraph.__typename} key={paragraph.id}><ImpactBlock {...paragraph} /></GridContainer>
      );
    case "PromoBlockParagraph":
      return (
        <GridContainer className={paragraph.__typename} key={paragraph.id}><PromoBlock {...paragraph} /></GridContainer>
      );
    case "StatisticsParagraph":
      return <Infographic {...paragraph} key={paragraph.id} />;
    case "NewsletterSignUpBlockParagraph":
      return (
        <NewsletterSignUpBlock key={paragraph.id} {...paragraph} />
      );
    case "ProjectInDetailSliderParagraph":
      return (
        <ProjectInDetailSlider key={paragraph.id} {...paragraph} />
      );
    case "AccordionParagraph":
      return (
        <GridContainer className={paragraph.__typename} key={paragraph.id}><Accordion {...paragraph} /></GridContainer>
      );
    case "FeatureCardParagraph":
      return (
        <FeatureCard key={paragraph.id} {...paragraph} />
      );
    case "CarouselParagraph":
      return (
        <div key={paragraph.id} style={{ overflow: 'hidden' }} className={paragraph.__typename}>
          <GridContainer>
            <Carousel {...paragraph} />
          </GridContainer>
        </div>
      );
    case "DownloadsParagraph":
      return (
        <GridContainer className={paragraph.__typename} key={paragraph.id}><DownloadButtons {...paragraph} /></GridContainer>
      );
    case "SpeciesParagraph":
      return (
        <GridContainer className={paragraph.__typename} key={paragraph.id}><SpeciesBlock {...paragraph} /></GridContainer>
      );
    case "ImagesParagraph":
      return (
        <Images key={paragraph.id} {...paragraph} />
      );
    case "GeneralListingParagraph":
      return (
        <GridContainer className={`${paragraph.__typename} ${'field_remove_spacing' in paragraph && paragraph.field_remove_spacing ? 'field-remove-spacing' : ''}`} key={paragraph.id}>
          <GeneralListing {...paragraph} />
        </GridContainer>
      );
    case "ImageGalleryParagraph":
      return (<ImageGallery {...paragraph} key={paragraph.id} />);
    case "InPageTabsParagraph":
      return (
        <div className={paragraph.__typename} key={paragraph.id}>
          <InPageTabs {...paragraph} />
        </div>
      );
    case "WebformParagraph":
      return (
        <Webform key={paragraph.id} {...paragraph} />
      );
    case "PillarParagraph":
      return (
        <FourPillars key={paragraph.id} {...paragraph} />
      );
    case "TodayAtTheZooListingParagraph":
      return (
        <TodayAtZooListing key={paragraph.id} {...paragraph} />
      );
    case "InfoBlockParagraph":
      return (
        <InfoBlock key={paragraph.__typename} {...paragraph} />
      );
    case "FeatureCard2_3Paragraph":
      return (
        <FeatureCardVariant key={paragraph.id} {...paragraph} />
      );
    case "TestimonialsParagraph":
      return (
        <TestimonialBlockQuote key={paragraph.id} {...paragraph} />
      );
    case "EventListingParagraph":
      return(
        <EventListing key={paragraph.id} {...paragraph} />
      )
    case "TextImageParagraph":
      return(
        <TextImage key={paragraph.id} {...paragraph} />
      )
    case "ImageComparisonParagraph":
      return(
        <GridContainer className={paragraph.__typename} key={paragraph.id}><ImageComparison key={paragraph.id} {...paragraph} /></GridContainer>
      )
    case "VideoComponentParagraph":
      return(
        <GridContainer className={paragraph.__typename} key={paragraph.id}><VideoComponent key={paragraph.id} {...paragraph} /></GridContainer>
      )
    case "MapParagraph":
      return(
        <GridContainer className={paragraph.__typename} key={paragraph.id}><Map key={paragraph.id} {...paragraph} /></GridContainer>
      )
    default:
      // @ts-ignore: Handling for unimplemented paragraphs
      return (<></>);
  }
};

export type SlicesProps = {
  content: SlicesParagraph[];
};

const Slices = (content?: SlicesParagraph[]): ReactElement<any> => {
  if (content) {
    return (<>{Object.keys(content).map((key, i) => renderParagraph(content[i], i))}</>);
  }

  return <></>;
};

export default Slices;
